import { queryOptions } from '@tanstack/react-query';
import fetchClient from '@eureca/recruiter-api-sdk/client';
import type { GetProgramsIdAlignmentForm200 } from '@eureca/recruiter-api-sdk/types';

/**
 * DEV-269 — leitura do formulário de alinhamento do programa. Sem edição
 * prévia o BFF devolve o template canônico com `surveyVersion: null` (AC-31);
 * `restrictions` vem sempre do backend (FR-010). Tipo gerado pelo SDK do BFF
 * (`definition` é o JSON do SurveyJS, opaco).
 */
export type AlignmentForm = GetProgramsIdAlignmentForm200;

export class AlignmentFormFetchError extends Error {
  readonly name = 'AlignmentFormFetchError';
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}

export function alignmentFormQueryKey(programId: string) {
  return ['recruiter', 'programs', 'alignment-form', programId] as const;
}

export function alignmentFormQueryOptions(programId: string) {
  return queryOptions({
    queryKey: alignmentFormQueryKey(programId),
    queryFn: async ({ signal }) => {
      const res = await fetchClient<AlignmentForm>({
        method: 'GET',
        url: `/programs/${programId}/alignment-form`,
        signal,
      });
      if (res.error) {
        throw new AlignmentFormFetchError(
          `Failed to load alignment form (status ${res.error.status})`,
          res.error.status
        );
      }
      return res.data;
    },
    // A definição é editada em memória pelo construtor: nunca refetch em
    // background enquanto a tela está aberta (clobber do rascunho).
    staleTime: Infinity,
    retry: (failureCount, err) => {
      if (err instanceof AlignmentFormFetchError && err.status >= 400 && err.status < 500) {
        return false;
      }
      return failureCount < 2;
    },
  });
}
